import React, { useEffect, useState } from "react";
import { CalendarHeart, CheckCircle2, RefreshCw } from "lucide-react";
import { api, fmtDateTime } from "../../lib/api";
import { AdminHeader } from "../../components/AdminLayout";

const GenderBadge = ({ g }) => (g ? (
  <span className={`text-[10px] font-bold rounded px-1.5 py-0.5 ${g === "F" ? "bg-[#EC4899]/20 text-[#f9a8d4]" : "bg-[#5CC8FF]/20 text-[#7dd3fc]"}`}>{g}</span>
) : null);

export default function AdminSocialRoster() {
  const [data, setData] = useState(null);
  const load = () => api.get("/admin/social-roster").then((r) => setData(r.data)).catch(() => setData([]));
  useEffect(() => { load(); }, []);
  const rosters = data || [];

  return (
    <div>
      <AdminHeader
        title="Social Roster"
        subtitle="Who's coming to each social night — built from pass purchases"
        action={<button onClick={load} data-testid="roster-refresh" className="flex items-center gap-2 bg-white/5 border border-white/10 rounded-full px-4 py-2 text-sm"><RefreshCw size={15} className="text-[#D4AF37]" /> Refresh</button>}
      />
      {data === null ? (
        <p className="text-[#A19DB0]">Loading…</p>
      ) : rosters.length === 0 ? (
        <div className="text-center py-16 text-[#A19DB0]" data-testid="roster-empty">
          <CalendarHeart size={40} className="mx-auto mb-3 opacity-50" />
          <p>No upcoming socials yet.</p>
        </div>
      ) : (
        <div className="space-y-5">
          {rosters.map((r) => (
            <div key={r.event.id} data-testid={`social-roster-${r.event.id}`} className="rounded-2xl bg-white/5 border border-white/10 overflow-hidden">
              <div className="flex items-center justify-between gap-3 p-4 border-b border-white/10" style={{ borderLeft: `4px solid ${r.event.color || "#D4AF37"}` }}>
                <div className="min-w-0">
                  <h3 className="font-display text-xl font-bold truncate">{r.event.title}</h3>
                  <p className="text-[#A19DB0] text-sm">{fmtDateTime(r.event.starts_at)}{r.event.location ? ` · ${r.event.location}` : ""}</p>
                </div>
                <div className="text-right shrink-0">
                  <p className="font-display text-2xl font-bold text-[#D4AF37]" data-testid={`roster-count-${r.event.id}`}>{r.count}</p>
                  <p className="text-[#A19DB0] text-[11px] uppercase tracking-wide flex items-center gap-1 justify-end"><CheckCircle2 size={12} className="text-[#4ADE80]" /> {r.checked_in} in</p>
                </div>
              </div>
              {r.guests.length === 0 ? (
                <p className="text-[#A19DB0] text-sm p-4">No passes bought for this night yet.</p>
              ) : (
                <ul className="divide-y divide-white/5">
                  {r.guests.map((g) => (
                    <li key={g.pass_id} data-testid={`roster-guest-${g.pass_id}`} className="flex items-center gap-3 px-4 py-3">
                      <span className="w-9 h-9 rounded-full bg-[#9D4EDD]/20 text-[#c79bff] flex items-center justify-center text-sm font-semibold shrink-0">{(g.name || "?").slice(0, 1).toUpperCase()}</span>
                      <div className="flex-1 min-w-0">
                        <p className="font-medium truncate flex items-center gap-1.5">{g.name} <GenderBadge g={g.gender} /></p>
                        <p className="text-[#A19DB0] text-xs truncate">{g.package_name}{g.option ? ` · ${g.option}` : ""}{g.shared_by ? ` · shared by ${g.shared_by}` : ""}</p>
                      </div>
                      {g.checked_in
                        ? <span className="text-[#4ADE80] text-xs flex items-center gap-1 shrink-0"><CheckCircle2 size={14} /> In</span>
                        : <span className="text-[#A19DB0] text-xs shrink-0">Not in</span>}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
